export default "__VITE_ASSET__B3Xty46t__"